<template>
    <transition>
        <MainLayout>
            <keep-alive>
                <router-view
                    :key="routerViewKey"
                    v-if="$route.meta.keepAlive"
                ></router-view>
            </keep-alive>
            <router-view
                :key="routerViewKey"
                v-if="!$route.meta.keepAlive"
            ></router-view>
        </MainLayout>
    </transition>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { queryDictionaryValue } from './api/base';
import { getLocal, groupBy } from './utils/func';
import MainLayout from './components/layout/MainLayout';
import eventBus from '@/utils/eventBus';
import { injectEnv } from '@/inject/env';

export default {
    name: 'App',
    components: { MainLayout },
    data() {
        return {
            routerViewKey: 0,
        };
    },
    computed: {
        ...mapGetters({
            excludeCache: 'comon/excludeCache',
            userInfo: 'comon/userInfo',
        }),
    },
    created() {
        window.GITHASH = process.env.GITHASH;
        this.getDictList();
        // mockMenu().then((res) => {
        //     sortOutMenu.call(this, {
        //         data: res,
        //     });
        // });
        let user = localStorage.getItem('userInfo');

        user = user ? JSON.parse(user) : {};

        if (Object.keys(user).length > 0) {
            this.updateUserInfo(user);
        }
    },
    mounted() {
        this.refreshView();
        this.setCurrentAuthBtn();
    },
    methods: {
        ...mapActions('comon', ['updateUserInfo']),
        setCurrentAuthBtn() {
            const btnList = getLocal('currentAuthBtn', true);
            if (btnList) {
                this.$store.commit('comon/setCurrentAuthBtn', btnList);
            }
        },
        async getDictList() {
            const res = await queryDictionaryValue({
                    pageNum: 1,
                    pageSize: -1,
                }),
                list = res.data || [],
                obj = groupBy(list, (item) => item.dictionaryCode);

            this.$store.commit('comon/setDictData', obj);
        },
        refreshView() {
            eventBus.$on('org-change', (item) => {
                this.$store.commit('comon/setUserInfo', {
                    ...this.userInfo,
                    ...item.employee,
                });
                this.routerViewKey++;
            });
        },
    },
};
</script>
